import { useState } from "react";

export const useSelectedChannels = () => {
  const [selectedChannels, setSelectedChannels] = useState([]);

  const onToggle = (channel) => {
    setSelectedChannels((prevSelectedChannels) => {
      if (prevSelectedChannels.includes(channel)) {
        return prevSelectedChannels.filter((c) => c !== channel);
      } else {
        return [...prevSelectedChannels, channel];
      }
    });
  };

  return { selectedChannels, onToggle, setSelectedChannels };
};
